import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./../../../css/navbar.css";
import $ from "jquery";
import auth from "../../../core/auth";
import { confirmAlert } from "react-confirm-alert";
import useCheckMobileScreen from "./../readingView/useCheckMobileScreen";

export default function Navbar(props) {
  let isMobile = useCheckMobileScreen();
  const history = useHistory();
  useEffect(() => {
    $(".navbar-nav a").on("click", function () {
      $(".navbar-nav").find("li.active").removeClass("active");
      $(this).parent("li").addClass("active");

      if ($(".navbar-nav").find("li.active").attr("id") !== "viewTab") {
        $(".navbar-collapse").collapse("hide");
      }
    });
  });
  const options = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">Logout</h1>
          <p className="alert__body">Proceed ?</p>
          <button
            onClick={() => {
              auth.logout(() => {
                history.push("/");
              });
              onClose();
            }}
            className="btn btn-primary"
          >
            Yes
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            No
          </button>
        </div>
      );
    },
  };

  function normalalertask() {
    if (window.confirm("Proceed to logout?")) {
      auth.logout(() => {
        history.push("/");
      });
    }
  }

  return (
    <nav
      role="navigation"
      className="navbar fixed-top navbar-default navbar-expand-lg navbar-light bg-light "
    >
      <a
        className="navbar-brand mb-0 h1"
        href="https://www.sascontrollers.com/"
        target="_blank"
      >
        <img
          src={require("./../../../images/surflogoo.png")}
          width={isMobile ? "15" : "40"}
          height={isMobile ? "15" : "40"}
          alt="S. 	&amp;A.S.Co.Ltd"
        />
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item" id="homeTab">
            <a className="nav-link" onClick={() => history.push("/home")}>
              Home
            </a>
          </li>
          <li className="nav-item" id="infoTab">
            <a className="nav-link" onClick={() => history.push("/info")}>
              Info
            </a>
          </li>
          <li className="nav-item dropdown " id="viewTab">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              View
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                className="dropdown-item"
                onClick={() => history.push("/map")}
                id="mapTab"
              >
                <center>Map</center>
              </a>
              <a
                className="dropdown-item"
                onClick={() => history.push("/grid")}
                id="gridTab"
              >
                <center>Grid</center>
              </a>
              <a
                className="dropdown-item"
                onClick={() => history.push("/list")}
                id="listTab"
              >
                <center>List</center>
              </a>
              <div className="dropdown-divider" />
            </div>
          </li>
          <li className="nav-item">
            <a className="nav-link " onClick={() => history.push("/Add-Site")}>
              Add Site
            </a>
          </li>
          <li className="nav-item" id="logoutTab">
            <a
              className="nav-link "
              onClick={() => {
                window.location.pathname == "/map"
                  ? normalalertask()
                  : confirmAlert(options);
              }}
            >
              Logout
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
